import { defineComponent as _defineComponent } from 'vue'
import bugsnag from '../../global/bugsnag';
import globalData from '../../global/window-data';
import HeaderAccount from './menus/account/HeaderAccount.vue';
import HeaderCart from './menus/cart/HeaderCart.vue';
import HeaderLogo from './HeaderLogo.vue';
import HeaderNavigation from './HeaderNavigation.vue';
import Icon from 'JS/components/Icon.vue';
import MobileMenu from './menus/MobileMenu.vue';
import resourceService from '../../services/GlobalResourceService';
import SearchBar from './SearchBar.vue';
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { EventBusEvents } from 'Src/js/types/EventBus';
import { IHeaderJson } from 'Src/js/types/Header';
import { IQuickCartSummaryJson } from 'Src/js/types/Order';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const headerData = ref<IHeaderJson>({} as IHeaderJson);
const mobileMenuOpen = ref(false);
const openMobileMenuButton = ref<HTMLButtonElement | null>();

const { isDesktop } = useBreakpoints();

async function loadData() {
	try {
		const data = await resourceService.getHeaderData();
		headerData.value = data;

		window.vueEventBus?.$emit(EventBusEvents.UpdateQuickCart, data.cartSummaryJson);
	} catch (e) {
		bugsnag.notify(e);
	}
}

const filteredHeaderData = computed(()=> {
	return {
		...headerData.value,
		headerAds: headerData.value?.headerAds?.filter(ad => headerAdFilter(ad.text))
	};
});

function headerAdFilter(adText: string) {
	if (adText === "Free Shipping on Orders $79+ for Rewards Members") return true;
	if (adText.toLowerCase().startsWith("ship") || adText.toLowerCase().includes(" ship")) return false;
	return true;
}

function handleMobileMenuOpen() {
	mobileMenuOpen.value = true;

	window.blainGtmDataLayer.push({
		'menuName': "main",
		'event': "menu_open"
	});
}

function handleMobileMenuClose() {
	mobileMenuOpen.value = false;
	openMobileMenuButton.value.focus();
}

onBeforeMount(() => {
	try {
		if (typeof document === 'undefined') return;
		const header = document.getElementById("websiteHeader");
		headerData.value = JSON.parse(header.getAttribute('data-header-data'));

		window.addEventListener('pageshow', async (e) => {
			await loadData();
			const navigation = performance.getEntriesByType('navigation')[0];
			if (!navigation) {
				return;
			}
			if (e.persisted || ('PerformanceNavigationTiming' in window && navigation instanceof PerformanceNavigationTiming && navigation.type === 'back_forward')) {
				if (headerData.value.loggedIn !== !!globalData.customer) {
					window.location.reload();
				}
			}
		});

		window.vueEventBus.$on('header-vm', (data: IHeaderJson) => {
			headerData.value = data;
		});
		window.vueEventBus.$on(EventBusEvents.UpdateQuickCart, (cartSummary: IQuickCartSummaryJson) => {
			headerData.value.cartSummaryJson = cartSummary;
			headerData.value.itemsInCartCount = cartSummary.cartQty;
		});
	} catch (e) {
		bugsnag.notify(e);
	}
});

onMounted(() => {
	window.vueEventBus.$on(EventBusEvents.LoginSuccess, loadData);
});


return { __sfc: true,headerData, mobileMenuOpen, openMobileMenuButton, isDesktop, loadData, filteredHeaderData, headerAdFilter, handleMobileMenuOpen, handleMobileMenuClose, HeaderAccount, HeaderCart, HeaderLogo, HeaderNavigation, Icon, MobileMenu, SearchBar }
}

})